interface LoadingScreenProps {
  message?: string;
  fullHeight?: boolean;
}

export function LoadingScreen({ message = 'Loading...', fullHeight = true }: LoadingScreenProps) {
  return (
    <div
      className="surface surface-padding"
      style={{
        minHeight: fullHeight ? '240px' : undefined,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        textAlign: 'center'
      }}
    >
      <div className="spinner" aria-hidden />
      <div>{message}</div>
    </div>
  );
}

